import { Box, Link, Text } from '@factorialco/deprecated-design-system'
import { TransactionDetailFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { CustomDetails } from 'modules/banking/components/AccountTransactionsDataTable/TransactionDetailSidePanel/CustomDetails'
import AmountWithCurrency from 'modules/expenses/lib/transactions/AmountWithCurrency'

export const DisputeDetails = (transaction: TransactionDetailFragment) => {
  const { navigation } = useNavigation()
  const dispute = transaction.dispute
  if (!dispute?.disputedTransaction) return null

  const disputedTransactionUrl =
    navigation.finance.banking.accounts.accountId.transactions.transactionId.fullPath({
      id: transaction.bankAccount.id,
      transaction_id: dispute?.disputedTransaction.id,
    })

  return (
    <CustomDetails title={i18n.t('banking.transactions.disputes.information')}>
      <Box width="full" flexDirection="row" justifyContent="flexStart" alignItems="flexStart">
        <Box width="full" textAlign="left" gap="s8">
          <Text weight="medium" size="300" color="grey1000">
            {i18n.t('banking.transactions.disputes.disputed_amount')}
          </Text>
          <Text weight="normal" size="300" color="grey800">
            <AmountWithCurrency
              amount={dispute.disputedTransaction.amountCents}
              currency={dispute.disputedTransaction.currency}
            />
          </Text>
        </Box>
        <Box width="full" textAlign="left" gap="s8">
          <Text weight="medium" size="300" color="grey1000">
            {i18n.t('banking.transactions.disputes.disputed_transaction_date')}
          </Text>
          <Text weight="normal" size="300" color="grey800">
            {dateBackendDateTimeToUI(dispute.disputedTransaction.bookingDate)}
          </Text>
        </Box>
      </Box>
      <Link.Router to={disputedTransactionUrl}>
        {i18n.t('expenses_v2.transactions.detail.actions.view_disputed_transaction_details')}
      </Link.Router>
    </CustomDetails>
  )
}
